import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WarehouseService {
    // Temporalmente sin environment.warehouseUrl
    private _warehouseUrl = new BehaviorSubject<string>('');

    get warehouseUrl$(): Observable<string> {
        return this._warehouseUrl.asObservable();
    }

    set warehouseUrl$(url: string) {
        this._warehouseUrl.next(url);
    }

    setWarehouseUrl(baseUrl: string, route?: string): void {
        this._warehouseUrl.next(baseUrl);
        const path = route?.replace(/^\/(?:external\/)?wms\/?/, '') || null;
        this._warehousePath.next(
            path ? (path.startsWith('/') ? path : `/${path}`) : null
        );
    }

    private _warehousePath = new BehaviorSubject<string | null>(null);

    get warehousePath$(): Observable<string | null> {
        return this._warehousePath.asObservable();
    }

    constructor() {}
}
